import * as React from 'react'

import reportError from 'airship/modules/report-error'
import MessageType from 'airship/widgets/new-push-popover/message-type'
import {refresh, updateUse} from 'airship/widgets/workflows/data'
import Workflow from 'airship/widgets/workflows/workflow'

const COLLAPSED_COUNT = 3

const WorkflowList: React.FC = () => {
  const [workflows, setWorkflows] = React.useState<Workflow[]>([])
  const [error, setError] = React.useState('')
  const [loading, setLoading] = React.useState(true)
  const [viewAll, setViewAll] = React.useState(false)

  React.useEffect(() => {
    refreshWorkflows()
  }, [])

  const filteredWorkflows = workflows.slice(
    0,
    viewAll ? workflows.length : COLLAPSED_COUNT
  )
  const showViewAllToggle = workflows.length > COLLAPSED_COUNT

  return (
    <>
      {!error ? (
        <>
          {!loading && filteredWorkflows.length > 0 && (
            <div className="u-contain-spread-sm u-space-ends-6 u-cf">
              <h2 className="u-flex u-flex-justify-between u-pad-top-2 u-text-shrink-1 u-text-uppercase u-text-bold">
                <span className="u-grey-60">
                  {viewAll ? 'All' : 'Recent'} Favorites
                </span>
                {showViewAllToggle && (
                  <button
                    className="button button--navy--inverse"
                    onClick={toggleViewAll}
                  >
                    View {viewAll ? 'Recent' : 'All'}
                  </button>
                )}
              </h2>
              <div>
                <div className="grid grid--with-gutter">
                  {filteredWorkflows.map(({id, name, urls}) => (
                    <div
                      className="grid-cell u-md-size-1of3 u-pad-top-1"
                      key={id}
                    >
                      <MessageType
                        key={id}
                        href={urls.use}
                        icon="composer-favorite"
                        title={name}
                        onClick={() => updateUse(id)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="u-contain-spread-sm u-space-ends-6 u-cf">
          <p className="u-text-center u-pad-top-1">{error}</p>
        </div>
      )}
    </>
  )

  function toggleViewAll(e: React.MouseEvent): void {
    e.preventDefault()

    setViewAll(!viewAll)
  }

  async function refreshWorkflows(): Promise<void> {
    setError('')
    setLoading(true)

    try {
      const {workflows} = await refresh()
      setLoading(false)
      setWorkflows(workflows)
    } catch (err) {
      setError('No favorites. Please refresh the page and try again.')
      reportError(err)
      setLoading(false)
    }
  }
}

export default WorkflowList
